import React from 'react'
import { ConectionsStatusContainer, ConnectionStatussesContainer } from './ConnectionStatus.styled'
import { StyledText } from '@clickcease/cc-client-components-lib'
import { Products } from 'Types/Product'
import { Platforms } from 'src/enums/platforms'
import { useGetPlatforms } from 'Features/domainsManagement/api/getPlatforms'
import { capitalize } from 'Utils/capitalize'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { getStatusStringByBooleans } from './ConnectionSatus.utils'
import { PlatformStatus } from './PlatformStatus'
import { useTranslation } from 'react-i18next'
import { CONNECTION_STATUS, PLATFORMS } from 'Types/PlatformsConnections'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const PRODUCT_PLATFORMS = {
  paidMarketing: [
    { name: PLATFORMS.GOOGLE },
    { name: PLATFORMS.META },
    { name: PLATFORMS.MICROSOFT },
  ],
}

export const ConnectionStatusPm = ({ product }: { product: Products }) => {
  const { t } = useTranslation('home')
  const platformsOfTheProduct = PRODUCT_PLATFORMS[product] as Record<'name', Platforms>[]
  const { setPmPlatformConnectionModal } = useAppStore()
  const navigate = useNavigate()
  const { owner } = useUserStore()

  const { data: platforms } = useGetPlatforms()

  const platformsWithSTatus = platformsOfTheProduct.map((platform) => {
    let enabled: boolean | undefined
    let connected: boolean | undefined

    const plarforms = platforms?.filter(
      (connections) => connections.platformType === capitalize(platform.name)
    )

    plarforms?.forEach((platform) => {
      if (platform.enabled) {
        enabled = platform.enabled
      }
      if (
        platform.connectionStatus === CONNECTION_STATUS.CONNECTED ||
        platform.connectionStatus === CONNECTION_STATUS.PENDING
      ) {
        connected = true
      }
    })

    return {
      ...platform,
      enabled,
      connected,
    }
  })

  const openPlatformWizard = (platform: Platforms | undefined) => {
    if (!platform) return
    navigate('/paid-marketing/platforms')
    setTimeout(() => {
      setPmPlatformConnectionModal(true, platform)
    }, 500)
  }

  return (
    <ConectionsStatusContainer>
      <StyledText variant={'baseLight'}>{t('connection_status')}</StyledText>
      <ConnectionStatussesContainer>
        {platformsWithSTatus.map((platform) => (
          <PlatformStatus
            key={platform.name}
            product={platform.name}
            status={getStatusStringByBooleans(platform.enabled, platform.connected)}
            onOpenModal={() => openPlatformWizard(platform.name)}
            disabled={!owner}
          />
        ))}
      </ConnectionStatussesContainer>
    </ConectionsStatusContainer>
  )
}
